import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, apiErr } from "@/lib/api";
import { Button, Input, Label } from "@/components/kit";
import { KeyRound, HardHat } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error("Lösenordet måste vara minst 6 tecken");
    if (pw !== pw2) return toast.error("Lösenorden matchar inte");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      toast.success("Lösenordet är uppdaterat");
      setTimeout(() => nav("/login"), 1500);
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-4">
      <div className="w-full max-w-md rise">
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-amber-500 text-slate-950"><HardHat size={24} /></div>
          <div>
            <div className="font-display text-lg font-bold text-white">TJ Entreprenadkonsult</div>
            <div className="text-xs uppercase tracking-widest text-amber-500">Återställ lösenord</div>
          </div>
        </div>
        <div className="rounded-2xl border border-slate-800 bg-slate-900/70 p-7">
          {done ? (
            <p className="text-sm text-slate-300">Klart! Du skickas till inloggningen…</p>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label>Nytt lösenord</Label>
                <Input data-testid="reset-password-input" type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Minst 6 tecken" required />
              </div>
              <div>
                <Label>Bekräfta lösenord</Label>
                <Input data-testid="reset-confirm-input" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Skriv igen" required />
              </div>
              <Button data-testid="reset-submit-button" type="submit" disabled={busy} className="w-full">
                <KeyRound size={16} /> {busy ? "Sparar…" : "Spara nytt lösenord"}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
